/* import __COLOCATED_TEMPLATE__ from './login.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import { action } from '@ember/object';
import openCenteredWindow from 'embercom/lib/open-centered-window';
import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';

interface Args {
  redirectUrl: string;
  appId: string | null;
}

export default class StandaloneCopilotLogin extends Component<Args> {
  private get baseUrl() {
    return new URL(this.args.redirectUrl).origin;
  }

  @action async openLoginWindow() {
    let loginWindow = openCenteredWindow(this.loginUrl, 800, this.loginWindowWidth);

    window.addEventListener('message', (event) => {
      if (event.data.type === 'login_complete') {
        loginWindow!.close();
        window.location.href = this.args.redirectUrl;
      }
    });
  }

  private get loginUrl() {
    if (this.shouldShowAuthorizedSignInMethods) {
      // redirect url here is needed for after sign in path with Google SSO
      return `${this.baseUrl}/a/sign-in/${this.args.appId}?redirect_url=${encodeURIComponent('/standalone/copilot/login_success')}`;
    } else {
      return `${this.baseUrl}/admins/sign_in`;
    }
  }

  private get shouldShowAuthorizedSignInMethods() {
    // we always pass an app id as a query param before rendering the frame-login page
    // this is more here in case we fail to have an app id so that customers can still sign in
    return isPresent(this.args.appId);
  }

  private get loginWindowWidth() {
    return this.shouldShowAuthorizedSignInMethods ? 1200 : 600;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Copilot::Login': typeof StandaloneCopilotLogin;
  }
}
